export default __webpack_public_path__ + "static/media/maarten.b378d403.png";